import * as runtime from '../runtime';
import type { LoginPayload, LoginResponse } from '../models';

export interface LoginRequest {
  loginPayload: LoginPayload;
}

/**
 *
 */
export class AuthApi extends runtime.BaseAPI {
  async loginRaw(
    requestParameters: LoginRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<LoginResponse>> {
    if (
      requestParameters.loginPayload === null ||
      requestParameters.loginPayload === undefined
    ) {
      throw new runtime.RequiredError(
        'loginPayload',
        'Required parameter requestParameters.loginPayload was null or undefined when calling login.',
      );
    }

    const queryParameters: Record<
      string,
      string | string[] | number | boolean
    > = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request(
      {
        path: `/customer/login`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: requestParameters.loginPayload,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response);
  }

  /**
   * Login user.
   */
  async login(
    requestParameters: LoginRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<LoginResponse> {
    const response = await this.loginRaw(requestParameters, initOverrides);
    return await response.value();
  }

  async meRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<any>> {
    const queryParameters: Record<
      string,
      string | string[] | number | boolean
    > = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/auth/me`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response);
  }

  /**
   * Get current user profile.
   */
  async me(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<any> {
    const response = await this.meRaw(initOverrides);
    return await response.value();
  }
}
